var map = {
	"./elixir_logo.png": 3984,
	"./java_logo.png": 3832,
	"./js_logo.png": 4648,
	"./mongodb_logo.png": 2228,
	"./postgresql_logo.png": 900,
	"./react_logo.png": 9528,
	"./ruby_logo.png": 2916,
	"./vue_logo.png": 2936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;